export default "__VITE_ASSET__BbvuUJ47__"